module.exports = __webpack_public_path__ + "img/GAME_BUNGEOPPANG2.8a2dca46.jpg";